var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-f279c978-4a84-472d-a3f3-de19a9b1eca5",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 89.6 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.6,31.57s0,14.67-1.87,21.71c-1.03,3.88-4.07,6.81-7.92,7.85-6.99,1.88-35.01,1.88-35.01,1.88,0,0-28.02,0-35.01-1.88-3.86-1.04-6.89-3.97-7.92-7.85C0,46.24,0,31.57,0,31.57c0,0,0-14.67,1.87-21.71C2.9,5.98,5.94,2.92,9.79,1.88,16.78,0,44.8,0,44.8,0c0,0,28.02,0,35.01,1.88,3.85,1.04,6.89,4.09,7.92,7.97,1.87,7.03,1.87,21.71,1.87,21.71Zm-30.55,0l-23.42-13.32v26.65l23.42-13.32Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkYoutube);
export default __webpack_public_path__ + "static/media/dark - youtube.51bfc0c191caf3f9e5c888e187dfe03e.svg";
export { ForwardRef as ReactComponent };